import api from '@/helpers/api';
import { ERROR_MSGS } from '../wallet.constants';
import i18next from '@/helpers/i18n';
import { generateCorrelationId } from '@/tracing/utils';
import { globalTracer, Span } from 'opentracing';
import walletBannerOpts from '../wallet.banners';

const opentracing = require('opentracing');

export async function getEnvelope(token: string, span: Span) {
  try {
    const correlationId = generateCorrelationId();
    const tracer = globalTracer();
    const headers = { ...api.defaults.headers.get, 'TMPS-Correlation-Id': correlationId };
    tracer.inject(span, opentracing.FORMAT_HTTP_HEADERS, headers);
    span.setTag('tm.correlation_id', correlationId);
    span.setTag(opentracing.Tags.HTTP_METHOD, 'GET');
    span.setTag(opentracing.Tags.HTTP_URL, `/envelopes/${token}/token`);
    const result = await api.get(`/envelopes/${token}/token`, { params: { language: i18next.language }, headers: headers });
    span.setTag(opentracing.Tags.HTTP_STATUS_CODE, result.status);
    return result;
  } catch (err: any) {
    const { status = 500, data: { message = '', tmOrdersUrl } } = err?.response || { data: {} };
    const validate = { status: 'defaultError', tmOrdersUrl, message: 'defaultErrorMessage' };
    if (status === 401 || status === 403) {
      validate.status = 'forbidden';
    }
    if (status === 501) {
      validate.status = 'redemptionError';
      validate.message = err?.response?.data?.message;
    }
    if (status === 422) {
      validate.status = 'notReady';
    }
    if (status === 500) {
      validate.status = 'defaultError';
    }
    if (message.indexOf(ERROR_MSGS.REFUNDED) !== -1) {
      validate.status = 'noTickets';
    }
    if (message === ERROR_MSGS.ALREADY_REDEEMED) {
      validate.status = 'alreadyRedeemed';
    }
    span.setTag('error', true);
    span.setTag(opentracing.Tags.HTTP_STATUS_CODE, status);
    err.validate = validate;
    throw err;
  }
}

export async function redeemTickets(activeToken: string) {
  let language = i18next.language;
  try {
    if (!language) {
      language = 'en-US';
    }
    await redeem(activeToken, language);
  } catch (e) {
    return walletBannerOpts.redeemError();
  }
}

async function redeem(activeToken: string, language: string) {
  const url = `/envelopes/redeem/${activeToken}?language=${language}`;
  const result = await api.put(url);
  let uri = result.data.uri;

  if (uri.match('^http://')) {
    uri = uri.replace('http://', 'https://');
  }
  window.location.href = uri;
}
